import {Rental} from '../../../../common/types/rental'
import {computeProductRentalStatsRows} from './productRentalStats'

export interface ProductsInRentalsStats {
  id: string
  productName: string
  boxesCount: number
  rentalsCount: number
  rentalsPerBox: number
  rentalShare: number
  meanValueRatings: number
  ratingsSum: number
  validRatingsCount: number
  meanValueRentTime: number
  rentTimeSum: number
  rentTimeCount: number
}

export const getProductsInRentalsStats = (rentals: Rental[]): ProductsInRentalsStats[] => {
  return computeProductRentalStatsRows(rentals).map((r) => ({
    id: r.productId,
    productName: r.productName,

    rentalsCount: r.rentalsCount,
    boxesCount: r.boxesActiveCount,
    rentalsPerBox: r.rentalsPerActiveBox,
    rentalShare: r.rentalShare,

    meanValueRatings: r.meanRating,
    ratingsSum: r.ratingsSum,
    validRatingsCount: r.ratingsCount,

    meanValueRentTime: r.meanRentTime,
    rentTimeSum: r.rentTimeSum,
    rentTimeCount: r.rentTimeCount,
  }))
}
